/**
 * @args "123 456"
 * @returns "123456"
 */
export const removeSpaces = (text?: string) => text?.replace(/\s/g, '') || ''
